import React, { FC, useEffect, useState } from 'react';
import styled from 'styled-components';
import timer from '../img/timer.png';

interface TimerProps {
	time: number;
}

const Container = styled.div`
	position: relative;
	margin-top: 16px;
	border-radius: 5px;
	padding: 2px;
	display: flex;
	align-items: center;
	justify-content: center;
	background: linear-gradient(230deg, #bf37ff 0%, #333bed 43%, #0faaff 100%);
`;

const Wrapper = styled.div`
	padding: 10px;
	background: ${({ theme }) => theme.colors.bg1};
	width: 100%;
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 6px;
	border-radius: 3px;

	img {
		width: 16.375px;
	}

	p {
		background: ${({ theme }) => theme.colors.primaryGradient10};
		background-clip: text;
		-webkit-background-clip: text;
		-webkit-text-fill-color: transparent;
		font-size: 12px;
		font-weight: 700;
		line-height: 14px;
	}
`;

export const Timer: FC<TimerProps> = ({ time }) => {
	const formatTime = (seconds: number) => {
		const minutes = Math.floor(seconds / 60);
		const remainingSeconds = seconds % 60;
		return `${minutes.toString().padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`;
	};

	return (
		<Container>
			<Wrapper>
				<img src={timer} alt='timer' />
				<p>This offer ends in {formatTime(time)} min</p>
			</Wrapper>
		</Container>
	);
};
